import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import FormService from "../../services/FormService";
import CertificateService from "../../services/CertificateService";
import UserSignService from "../../services/UserSignService";

let initialState = {
    unsignedCertsCount: null,
    unsignedFormsCount: null,
    unsignedUserSignsDirectorCount: null,
    unsignedUserSignsRectorCount: null,
    isLoading: false,
    error: null,
}

export const countUnsignedCertificates = createAsyncThunk(
    'countUnsignedCertificates',
    async (_, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await CertificateService.countUnsignedCertificates();
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

export const countUnsignedForms = createAsyncThunk(
    'countUnsignedForms',
    async ({type}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await FormService.countFormsByType(type);
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

export const countUserSignsDirector = createAsyncThunk(
    'countUserSignsDirector',
    async (_, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await UserSignService.countUserSignsDirector();
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

export const countUserSignsRector = createAsyncThunk(
    'countUserSignsRector',
    async (_, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await UserSignService.countUserSignsRector();
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const counterSlice = createSlice({
    name: 'counterSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(countUnsignedCertificates.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.unsignedCertsCount = null;
            })
            .addCase(countUnsignedCertificates.fulfilled, (state, action) => {
                state.isLoading = false;
                state.unsignedCertsCount = action.payload;
            })
            .addCase(countUnsignedCertificates.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(countUnsignedForms.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.unsignedFormsCount = null;
            })
            .addCase(countUnsignedForms.fulfilled, (state, action) => {
                state.isLoading = false;
                state.unsignedFormsCount = action.payload;
            })
            .addCase(countUnsignedForms.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(countUserSignsDirector.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.unsignedUserSignsDirectorCount = null;
            })
            .addCase(countUserSignsDirector.fulfilled, (state, action) => {
                state.isLoading = false;
                state.unsignedUserSignsDirectorCount = action.payload;
            })
            .addCase(countUserSignsDirector.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(countUserSignsRector.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.unsignedUserSignsRectorCount = null;
            })
            .addCase(countUserSignsRector.fulfilled, (state, action) => {
                state.isLoading = false;
                state.unsignedUserSignsRectorCount = action.payload;
            })
            .addCase(countUserSignsRector.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
    }
});

export const {} = counterSlice.actions;

export default counterSlice.reducer;